module.exports = __webpack_public_path__ + "static/media/admin-login.1a56805d.jpg";